import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WorkflowEditorPage = Loadable(lazy(() => import("./WorkflowEditorPage")));

const WorkflowRoutes = [
  { path: "/workflow/configuration", element: <WorkflowEditorPage /> },
];

export default WorkflowRoutes;
